import { useTranslation } from 'react-i18next'

import { useRegisterReload } from '../../../hooks'
import { getEmptyStateActions, PageEmptyState } from '../../PageEmptyState'
import {
  useRequestProfileContext,
  useRequestProfileRatingActions,
} from '../RequestProfile.hooks'

import { QA_NAME_REQUEST_PROFILE_TAB_RATING_ADD_NEW } from './RequestProfileTabRating.constants'
import { useRequestProfileTabRatingList } from './RequestProfileTabRating.hooks'
import { RequestProfileTabRatingCard } from './RequestProfileTabRatingCard'

import * as styles from './RequestProfileTabRating.module.css'

import StarIcon from '../../../icons/star.svg'

function RequestProfileTabRating() {
  const { t } = useTranslation()

  const { registerRatingReload, requestData } = useRequestProfileContext()

  const { handleOpenRating, permissions } = useRequestProfileRatingActions()

  const {
    getThresholdItemProps,
    items,
    loading,
    loadingInitial,
    updateListData,
  } = useRequestProfileTabRatingList({ requestData })

  useRegisterReload({
    reload: updateListData,
    onRegisterReload: registerRatingReload,
  })

  const emptyStateActions = getEmptyStateActions({
    actionName: QA_NAME_REQUEST_PROFILE_TAB_RATING_ADD_NEW,
    qaName: QA_NAME_REQUEST_PROFILE_TAB_RATING_ADD_NEW,
    shouldShowActions: permissions?.can_add_feedback,
    text: t('RequestProfileTabRating.AddNewRatingBtnKey'),
    onClick: handleOpenRating,
  })

  const isEmpty = !loadingInitial && items?.length === 0

  return isEmpty ? (
    <PageEmptyState
      EntityIcon={StarIcon}
      actions={emptyStateActions}
      text={t('RequestProfileTabRating.NoRatingKey')}
    />
  ) : (
    <div className={styles.container}>
      {items?.map((item, index) => (
        <RequestProfileTabRatingCard
          {...getThresholdItemProps(index)}
          key={item.uuid || index}
          value={item}
        />
      ))}
      {loading ? <RequestProfileTabRatingCard loading /> : null}
    </div>
  )
}

export default RequestProfileTabRating
